import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class SharingServices {
    private readonly role = new BehaviorSubject<string>('');
    sharedMessage = this.role.asObservable();
    publishToken = new Subject<string>();

    image = new BehaviorSubject<{ id: any; image: any }>({ id: null, image: null });
    sharedImageMap = this.image.asObservable();

    constructor() { }
    
    nextMessage(message: string): void {
        this.role.next(message)
    }

    add(id: any, image: any): void {
        let item = { id, image };
        this.image.next(item);
    }
}